export default "__VITE_ASSET__BUxibbdo__"